// @ts-strict-ignore
import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { createSwiftAccountNumberSchema } from 'utils/yupSchemas/accountNumbersSchemas'
import { ALPHANUMERIC_VALIDATION, createNameSchema } from 'utils/yupSchemas/createNameSchema'
import { getBankAddressFields } from './fields/bankAddressFields'

export const addBeneficiaryBankDetailsSchema = (t: TFunction<'translation', undefined>) => {
  const intlIban = createSwiftAccountNumberSchema(t)
  const bicSwiftCode = createNameSchema(t('bicSwiftCode'), t, 8, null, ALPHANUMERIC_VALIDATION)
  const routingNumber = yup.string().label(t('abaRoutingNumber')).length(9)

  const {
    bankName,
    bankAddressLine1,
    bankAddressLine2,
    bankCity,
    bankPostCode,
    bankRegion,
    bankCountry,
  } = getBankAddressFields(t)

  const formFields = {
    intlIban,
    bicSwiftCode,
    routingNumber, // USD SWIFT
    bankName,
    bankAddressLine1,
    bankAddressLine2,
    bankCity,
    bankPostCode,
    bankRegion,
    bankCountry,
  }

  return yup.object(formFields)
}
